import type { TicketResolutionFieldKey, TicketWorkflow } from '@common/types';

export const TICKET_WORKFLOW_LABELS: Record<TicketWorkflow, string> = {
  central_complaint: 'Central complaint',
  in_the_moment: 'In-the-moment request',
};

export const TICKET_RESOLUTION_FIELD_LABELS: Record<TicketResolutionFieldKey, string> = {
  feedbackType: 'Feedback classification',
  dateOfFirstReply: 'Date of first reply',
  dateOfResolution: 'Date of resolution',
  compensationGiven: 'Compensation decision',
  sentiment: 'Guest sentiment',
  closingNotes: 'Closing notes',
  csat: 'CSAT eligibility',
};
